if (!customElements.get('size-dropdown')) {
  customElements.define(
    'size-dropdown',
    class SizeDropdown extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('[data-size-panel]');
        if (!this.details || !this.summary || !this.panel) return;

        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(!this.details.open);
        });

        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.toggle(false);
            this.summary.focus();
          }
        });

        // A size was picked: reflect it in the trigger instantly and collapse.
        // (variant-selects.js updates [data-selected-value] text; the whole
        // picker is then re-rendered from the server with the correct state.)
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

          const badge = this.querySelector('[data-soldout-badge]');
          if (badge) badge.classList.toggle('hidden', !input.classList.contains('disabled'));

          this.toggle(false);
        });
      }

      get animationsAllowed() {
        return (
          typeof this.panel.animate === 'function' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
      }

      toggle(open) {
        this.currentAnimation?.cancel();
        this.currentAnimation = null;

        if (open) {
          if (!this.details.open) this.details.open = true;
          if (!this.animationsAllowed) return;

          const height = this.panel.getBoundingClientRect().height;
          this.panel.style.overflow = 'hidden';
          this.currentAnimation = this.panel.animate(
            { height: ['0px', `${height}px`], opacity: [0, 1] },
            { duration: 220, easing: 'ease' }
          );
          this.currentAnimation.onfinish = () => {
            this.panel.style.overflow = '';
            this.currentAnimation = null;
          };
        } else {
          if (!this.details.open) return;
          if (!this.animationsAllowed) {
            this.details.open = false;
            return;
          }

          const height = this.panel.getBoundingClientRect().height;
          this.panel.style.overflow = 'hidden';
          this.currentAnimation = this.panel.animate(
            { height: [`${height}px`, '0px'], opacity: [1, 0] },
            { duration: 180, easing: 'ease' }
          );
          this.currentAnimation.onfinish = () => {
            this.panel.style.overflow = '';
            this.details.open = false;
            this.currentAnimation = null;
          };
        }
      }
    }
  );
}
